import * as diacritics from "diacritics";
import _flow from "lodash/flow";

export function replaceApostrophes(str) {
  return str.replace(/[ʻʼ’‘`´]/g, "'");
}

const removeDiacritics = diacritics.remove;

export const cleanQuery = _flow([
  replaceApostrophes,
  removeDiacritics,
  encodeURIComponent,
]);

export const getAutocomplete = (value, host) => {
  const query = cleanQuery(value);
  const url = `//${host}/search/autocomplete?q=${query}`;
  return fetch(url).then((response) => {
    // this should eventually be rolled into a utility function
    // pattern to create success / error callbacks (then/catch)
    if (response.ok) {
      return response.json();
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  });
};
